import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { Smartphone, FileText, Clock } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="py-24 bg-olive-green text-white relative overflow-hidden" data-id="element-15">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-16">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-17"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-8 leading-tight" data-id="element-20">
            Descárgalo hoy y empieza con tu primera receta en menos de 20
            minutos
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-21">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20 mb-12" data-id="element-22">
            <p className="text-white/60 text-lg mb-2 line-through decoration-white/40 decoration-2" data-id="element-23">
              Valor total percibido: $27
            </p>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-24">
              <span className="text-2xl font-bold text-white" data-id="element-25">Hoy solo:</span>
              <span className="text-5xl md:text-6xl font-serif font-bold text-warm-beige" data-id="element-26">
                $8.39
              </span>
            </div>
            <ButtonCTA href="https://www.tumundoequilibrado.com/cart/51321217220903:1" external className="w-full md:w-auto text-lg px-12 py-4 bg-emerald-500 text-white hover:bg-emerald-600" data-id="element-27" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-28">
          <div className="flex flex-wrap justify-center gap-6 mb-16 text-white/80" data-id="element-29">
            <div className="flex items-center" data-id="element-30">
              <Clock size={20} className="mr-2" data-id="element-31" />
              <span data-id="element-32">Acceso inmediato</span>
            </div>
            <div className="flex items-center" data-id="element-33">
              <FileText size={20} className="mr-2" data-id="element-34" />
              <span data-id="element-35">Formato PDF</span>
            </div>
            <div className="flex items-center" data-id="element-36">
              <Smartphone size={20} className="mr-2" data-id="element-37" />
              <span data-id="element-38">Lectura fácil desde cualquier dispositivo</span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-39">
          <div className="bg-black/20 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10" data-id="element-40">
            <p className="text-2xl md:text-3xl font-serif font-bold mb-6 text-warm-beige" data-id="element-41">
              No necesitas otra dieta imposible.
            </p>
            <p className="text-xl md:text-2xl font-serif mb-8 text-white/90" data-id="element-42">
              Necesitas un sistema que funcione en la vida real.
            </p>
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl mx-auto" data-id="element-43">
              Sabores que Adelgazan fue creado para ayudarte a comer mejor sin
              sentir que estás renunciando a todo. Si quieres una forma más
              simple, más rica y más sostenible de avanzar, este puede ser tu
              siguiente paso.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}